import React from 'react'
import { MDXTag } from '@mdx-js/tag'


const layoutProps = {};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props);
    this.layout = null;
  }

  render() {
    const {
      components,
      ...props
    } = this.props;
    return <MDXTag name="wrapper" components={components}><MDXTag name="p" components={components}><MDXTag name="a" components={components} parentName="p" props={{
          "href": "/snippets/main/act-structure/",
          "title": "ACT, directory structure"
        }}>{`A snippet`}</MDXTag>{` of the ACT directory structure`}</MDXTag>
      <MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{
          "className": "language-sh"
        }}>{`ACT project 
│
└───src
│   │
│   └───components // project components 
│   │
│   └───content // resources used to construct pages
│   │   │   
│   │   └───config // common configuration files (\*.yaml, \*.json, etc)
│   │   │   
│   │   └───images // a logo and other images
│   │   │
│   │   └───pages  // unique complex pages (the main page, index of posts, etc)
│   │   │
│   │   └───posts  // blog posts (markdown files)
│   │   │
│   │   └───snippets  // snippets
│   │       │
│   │       └───main  // a <main> collection of snippets (a directory with markdown files)
│   │       │
│   │       └───main.yaml  // a configuration file (corresponding to the <main> collection)
│   │
│   └───generated // pages generated using lodash templates (gatsby-plugin-combine)
│   │
│   └───helpers // helper modules (gatsby-plugin-combine)
│   │
│   └───pages // standard Gatsby pages
│   │
│   └───templates // lodash templates (gatsby-plugin-combine)
│   
└───data // data files saved by helper modules (gatsby-plugin-combine)
`}</MDXTag></MDXTag>
           </MDXTag>;
  }

}
export const _frontmatter = {
  "title": "ACT, directory structure",
  "keywords": "ACT, directory structure",
  "menu": "act blog/structure"
};
    